
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 96","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"31.25","y":"8.25","width":"33.5","height":"79.5","rx":"7.75","fill":"currentColor","fill-opacity":".07","stroke":"currentColor","stroke-width":"2.5"}}),_c('rect',{attrs:{"x":"38","y":"21","width":"20","height":"47","rx":"2.5","fill":"currentColor","fill-opacity":".16"}}),_c('path',{attrs:{"d":"M43 15h10","stroke":"currentColor","stroke-width":"2.5","stroke-linecap":"round","opacity":".45"}}),_c('circle',{attrs:{"cx":"48","cy":"78","r":"4","fill":"currentColor","fill-opacity":".45"}})])
          )
        }
      }
    